import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=6f79f968&scoped=true"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=6f79f968&lang=css"
import style1 from "./forgot-password.vue?vue&type=style&index=1&id=6f79f968&lang=scss&scoped=true"
import style2 from "./forgot-password.vue?vue&type=style&index=2&id=6f79f968&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f79f968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f79f968')) {
      api.createRecord('6f79f968', component.options)
    } else {
      api.reload('6f79f968', component.options)
    }
    module.hot.accept("./forgot-password.vue?vue&type=template&id=6f79f968&scoped=true", function () {
      api.rerender('6f79f968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/login/forgot-password.vue"
export default component.exports